/* Haluan Forge theme script. Vanilla JS, no dependencies. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const T = window.theme || { routes: {} };
  const money = (cents) => {
    const fmt = T.moneyFormat || '${{amount}}';
    const v = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, v.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  };
  const toast = (msg) => {
    const t = document.createElement('div');
    t.className = 'toast'; t.setAttribute('role', 'status'); t.textContent = msg;
    document.body.appendChild(t); setTimeout(() => t.remove(), 3200);
  };

  /* Announcement rotator */
  $$('[data-rotator]').forEach((track) => {
    const msgs = $$('.announce__msg', track);
    if (msgs.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let i = 0;
    setInterval(() => { msgs[i].classList.remove('is-active'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-active'); }, 4500);
  });

  /* Mobile nav: close on Escape / outside click */
  const mnav = $('[data-mnav]');
  if (mnav) {
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') mnav.open = false; });
    document.addEventListener('click', (e) => { if (mnav.open && !$('.mnav__panel', mnav).contains(e.target) && !$('summary', mnav).contains(e.target)) mnav.open = false; });
  }

  /* Search modal + predictive search */
  const sModal = $('[data-search-modal]');
  const sInput = $('[data-predictive-input]');
  const sResults = $('[data-predictive-results]');
  const openSearch = () => { if (!sModal) return; sModal.hidden = false; sInput && sInput.focus(); };
  const closeSearch = () => { if (sModal) sModal.hidden = true; };
  $$('[data-search-open]').forEach((b) => b.addEventListener('click', openSearch));
  $$('[data-search-close]').forEach((b) => b.addEventListener('click', closeSearch));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeSearch(); });
  let sTimer, sCtrl;
  sInput && sInput.addEventListener('input', () => {
    clearTimeout(sTimer);
    const q = sInput.value.trim();
    if (q.length < 2) { sResults.innerHTML = ''; return; }
    sTimer = setTimeout(async () => {
      try {
        sCtrl && sCtrl.abort(); sCtrl = new AbortController();
        const url = `${T.routes.predictiveSearch || '/search/suggest'}.json?q=${encodeURIComponent(q)}&resources[type]=product,article,collection,page&resources[limit]=5&resources[options][unavailable_products]=last`;
        const res = await fetch(url, { signal: sCtrl.signal });
        const data = await res.json();
        const r = data.resources.results;
        const esc = (s) => String(s || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
        let html = '';
        const group = (title, items, fn) => { if (items && items.length) html += `<p class="predictive__head">${title}</p><ul role="listbox">${items.map(fn).join('')}</ul>`; };
        group('Products', r.products, (p) => `<li><a href="${p.url}">${p.image ? `<img src="${p.image}${p.image.includes("?") ? "&" : "?"}width=96" alt="" width="48" height="48" loading="lazy">` : ''}<span><strong>${esc(p.title)}</strong><br><span class="muted">${money(Math.round(parseFloat(p.price) * 100))}</span></span></a></li>`);
        group('Collections', r.collections, (c) => `<li><a href="${c.url}">${esc(c.title)}</a></li>`);
        group('Guides', r.articles, (a) => `<li><a href="${a.url}">${esc(a.title)}</a></li>`);
        group('Pages', r.pages, (p) => `<li><a href="${p.url}">${esc(p.title)}</a></li>`);
        sResults.innerHTML = html || `<p class="muted">No quick matches. Press Enter to search everything.</p>`;
      } catch (err) { if (err.name !== 'AbortError') sResults.innerHTML = ''; }
    }, 220);
  });

  /* Cart drawer */
  const drawerId = 'cart-drawer';
  const getDrawer = () => $('[data-cart-drawer]');
  let lastFocus;
  const openDrawer = () => {
    const d = getDrawer(); if (!d) return;
    lastFocus = document.activeElement; d.hidden = false; document.documentElement.style.overflow = 'hidden';
    const p = $('.drawer__panel', d); p && p.focus();
  };
  const closeDrawer = () => {
    const d = getDrawer(); if (!d) return;
    d.hidden = true; document.documentElement.style.overflow = '';
    lastFocus && lastFocus.focus && lastFocus.focus();
  };
  const renderDrawer = (html) => {
    if (!html) return;
    const wrap = document.createElement('div'); wrap.innerHTML = html;
    const fresh = $('[data-cart-drawer]', wrap); const old = getDrawer();
    if (fresh && old) { fresh.hidden = old.hidden; old.replaceWith(fresh); }
  };
  const updateCount = (count) => {
    $$('[data-cart-count]').forEach((el) => { el.textContent = count; el.hidden = count === 0; });
    $$('[data-cart-open]').forEach((el) => el.setAttribute('aria-label', `Cart, ${count} items`));
  };
  const refreshCount = async () => { const c = await (await fetch(`${T.routes.cart}.js`)).json(); updateCount(c.item_count); return c; };

  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-cart-open]');
    if (open && T.cartDrawer && getDrawer() && !document.body.classList.contains('template-cart')) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }
    const q = e.target.closest('[data-qty-change]');
    if (q) changeLine(q);
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && getDrawer() && !getDrawer().hidden) closeDrawer(); });

  async function changeLine(btn) {
    const line = btn.closest('[data-line]'); if (!line) return;
    const qty = parseInt(btn.dataset.qtyChange, 10);
    line.style.opacity = '.5';
    try {
      const res = await fetch(`${T.routes.cartChange}.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: line.dataset.key, quantity: Math.max(0, qty), sections: [drawerId] })
      });
      const data = await res.json();
      if (data.status && data.status >= 400) throw new Error(data.description || data.message);
      if (document.body.classList.contains('template-cart')) { location.reload(); return; }
      renderDrawer(data.sections && data.sections[drawerId]);
      updateCount(data.item_count);
    } catch (err) { toast(err.message || 'Could not update cart'); line.style.opacity = ''; }
  }

  /* AJAX add to cart (works with subscription selling_plan inputs added by apps) */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    const btn = $('[type=submit]', form); const err = $('[data-form-error]', form);
    btn && btn.classList.add('is-loading'); if (err) err.hidden = true;
    try {
      const fd = new FormData(form);
      /* Subscription apps (e.g. Appstle) may render their selling plan input outside the form */
      const sec = form.closest('[data-product-section]');
      if (sec && !fd.get('selling_plan')) {
        const plan = Array.from(sec.querySelectorAll('[name="selling_plan"]')).filter((i) => !form.contains(i) && !i.disabled && (!/radio|checkbox/.test(i.type) || i.checked)).pop();
        if (plan && plan.value) fd.set('selling_plan', plan.value);
      }
      fd.append('sections', drawerId);
      fd.append('sections_url', location.pathname);
      const res = await fetch(`${T.routes.cartAdd}.js`, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
      const data = await res.json();
      if (data.status) throw new Error(data.description || data.message || 'Could not add to cart');
      renderDrawer(data.sections && data.sections[drawerId]);
      await refreshCount();
      if (T.cartDrawer) openDrawer(); else toast('Added to cart');
      document.dispatchEvent(new CustomEvent('cart:added', { detail: data }));
    } catch (ex) {
      if (err) { err.textContent = ex.message; err.hidden = false; } else toast(ex.message);
    } finally { btn && btn.classList.remove('is-loading'); }
  });

  /* Cart note */
  const note = $('[data-cart-note]');
  if (note) {
    let nt; note.addEventListener('input', () => { clearTimeout(nt); nt = setTimeout(() => fetch(`${T.routes.cartUpdate}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) }), 500); });
  }

  /* Product page */
  $$('[data-product-section]').forEach((sec) => {
    const slides = $('[data-slides]', sec);
    const thumbs = $$('[data-thumb]', sec);
    thumbs.forEach((t) => t.addEventListener('click', () => {
      const i = +t.dataset.thumb; slides.scrollTo({ left: slides.clientWidth * i, behavior: 'smooth' });
    }));
    if (slides && thumbs.length) {
      slides.addEventListener('scroll', () => {
        const i = Math.round(slides.scrollLeft / slides.clientWidth);
        thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));
      }, { passive: true });
    }
    const qtyInput = $('.qty__input', sec);
    $$('[data-step]', sec).forEach((b) => b.addEventListener('click', () => {
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.dataset.step, 10));
    }));

    const picker = $('[data-variant-picker]', sec);
    const idInput = $('[data-variant-id]', sec);
    const addBtn = $('[data-add-btn]', sec);
    const addLabel = $('[data-add-label]', sec);
    const priceWrap = $('[data-price-wrap] [data-price]', sec);
    const stickyPrice = $('[data-sticky-price]');
    const stickyAdd = $('[data-sticky-add]');
    if (picker) {
      const variants = JSON.parse($('[data-variants]', picker).textContent);
      picker.addEventListener('change', () => {
        const selected = [];
        $$('fieldset', picker).forEach((fs) => { const c = $('input:checked', fs); if (c) selected[+c.dataset.optionIndex] = c.value; });
        const v = variants.find((v) => v.options.every((o, i) => selected[i] === undefined || selected[i] === o));
        if (!v) return;
        idInput.value = v.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
        addBtn.disabled = !v.available; addLabel.textContent = v.available ? 'Add to cart' : 'Sold out';
        if (stickyAdd) stickyAdd.disabled = !v.available;
        const html = v.compare_at_price > v.price
          ? `<span class="visually-hidden">Sale price</span><span class="price__now">${money(v.price)}</span><s class="price__was">${money(v.compare_at_price)}</s>`
          : `<span class="price__now">${money(v.price)}</span>`;
        if (priceWrap) { priceWrap.innerHTML = html; priceWrap.classList.toggle('price--sale', v.compare_at_price > v.price); }
        if (stickyPrice) stickyPrice.textContent = money(v.price);
        const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
        if (v.featured_media && slides) {
          const s = $(`[data-media-id="${v.featured_media.id}"]`, slides);
          s && slides.scrollTo({ left: s.offsetLeft, behavior: 'smooth' });
        }
      });
    }

    const sticky = $('[data-sticky-buy]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      new IntersectionObserver(([en]) => sticky.classList.toggle('is-shown', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(addBtn);
      stickyAdd && stickyAdd.addEventListener('click', () => addBtn.click());
    }
  });

  /* Prefetch other grind pages so switching grind is instant */
  const prefetched = new Set();
  $$('.pdp__opt .chips a.chip').forEach((a) => {
    const go = () => { if (prefetched.has(a.href)) return; prefetched.add(a.href); const l = document.createElement('link'); l.rel = 'prefetch'; l.href = a.href; document.head.appendChild(l); };
    a.addEventListener('mouseenter', go, { once: true }); a.addEventListener('touchstart', go, { once: true, passive: true });
    if ('requestIdleCallback' in window) requestIdleCallback(go);
  });

  /* Product recommendations */
  $$('[data-recs]').forEach(async (el) => {
    if (el.children.length) return;
    try {
      const html = await (await fetch(el.dataset.url)).text();
      const wrap = document.createElement('div'); wrap.innerHTML = html;
      const inner = $('[data-recs]', wrap); if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML;
    } catch (e) {}
  });

  /* Collection filters (no page reload) */
  const facets = $('[data-facets]');
  if (facets) {
    const sectionId = facets.closest('[id^="shopify-section-"]').id.replace('shopify-section-', '');
    const load = async (url, push = true) => {
      const results = $('[data-results]'); results && results.classList.add('is-loading');
      const u = new URL(url, location.origin); u.searchParams.set('section_id', sectionId);
      const html = await (await fetch(u)).text();
      const wrap = document.createElement('div'); wrap.innerHTML = html;
      ['[data-results]', '.facets__bar', '.facets__active'].forEach((s) => {
        const fresh = $(s, wrap); const old = $(s);
        if (fresh && old) old.replaceWith(fresh); else if (fresh && !old) $('[data-facets]').appendChild(fresh); else if (!fresh && old) old.remove();
      });
      u.searchParams.delete('section_id');
      if (push) history.pushState({ facets: true }, '', u);
    };
    document.addEventListener('change', (e) => {
      if (!e.target.matches('[data-facet-input]')) return;
      const f = $('[data-facets]'); const params = new URLSearchParams(new FormData(f));
      load(`${f.action}?${params.toString()}`);
    });
    document.addEventListener('click', (e) => {
      const a = e.target.closest('.facets__active a, .pager a');
      if (a && $('[data-facets]')) { e.preventDefault(); load(a.href); window.scrollTo({ top: $('[data-facets]').offsetTop - 120, behavior: 'smooth' }); }
    });
    window.addEventListener('popstate', () => load(location.href, false));
  }

  /* Article table of contents */
  const body = $('[data-article-body]'); const toc = $('[data-toc]');
  if (body && toc) {
    const hs = $$('h2', body);
    if (hs.length >= 3) {
      const ol = $('ol', toc);
      hs.forEach((h, i) => {
        if (!h.id) h.id = (h.textContent.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') || 'section') + '-' + i;
        const li = document.createElement('li'); const a = document.createElement('a');
        a.href = '#' + h.id; a.textContent = h.textContent; li.appendChild(a); ol.appendChild(li);
      });
      toc.hidden = false;
    }
  }
})();
